/* eslint-disable @typescript-eslint/no-unused-vars */
import { AutocompleteWithLabel, SelectWithLabel } from '@adotel/components'
import { useLazyQuery, useQuery } from '@apollo/client'
import { MenuItem, Paper } from '@material-ui/core'
import { FC, SetStateAction, useEffect } from 'react'

// import { getTranslate } from '../../localization'
import {
  CRSInventoryData,
  RoomTypeForInventory
} from '../../../types/inventory'
import { RoomtypeForAllocatedList } from '../../../types/inventoryAllocatedList'
// import { RatePlan } from '../../types/rateplan'
// import { RoomType } from '../../types/roomtype'
import useStyles from '../styles/InventorySecondaryFiltersBox.styles'
import InventoryRoomtypeRow from './InventoryRoomTypeRowMobile'

interface InventoryTableRoomTypeProps {
  roomtypes: RoomtypeForAllocatedList[]
  selectedRoomTypeCode: any
}
const InventoryTableRoomType: FC<InventoryTableRoomTypeProps> = ({
  roomtypes,
  selectedRoomTypeCode
}) => {
  const classes = useStyles()

  return (
    <>
      {selectedRoomTypeCode && selectedRoomTypeCode.value ? (
        <InventoryRoomtypeRow
          name={`${
            roomtypes.find(
              (roomtype) =>
                roomtype.basicDetails.roomtypeCode === selectedRoomTypeCode.code
            )?.basicDetails.name
          } (${
            roomtypes.find(
              (roomtype) =>
                roomtype.basicDetails.roomtypeCode === selectedRoomTypeCode.code
            )?.basicDetails.roomtypeCode
          })`}
          pooledAvailability={
            roomtypes
              .find(
                (roomtype) =>
                  roomtype.basicDetails.roomtypeCode ===
                  selectedRoomTypeCode.code
              )
              ?.detailsForEachDate.map((date) => ({
                date: date.date,
                value: date.pooledAvailability
              })) || []
          }
        />
      ) : (
        roomtypes.map((roomData: RoomtypeForAllocatedList, index) => (
          <InventoryRoomtypeRow
            name={`${roomData?.basicDetails.name} (${roomData.basicDetails.displayRoomTypeCode})`}
            pooledAvailability={roomData?.detailsForEachDate.map((date) => ({
              date: date.date,
              value: date.pooledAvailability
            }))}
          />
        ))
      )}
    </>
  )
}

export default InventoryTableRoomType
